// src/modules/requerimiento/components/ResumenRevision.jsx
import React from "react";
import { Box, Button, CircularProgress, Stack, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import RefreshIcon from "@mui/icons-material/Refresh";

/** Degradados por tipo de requerimiento, los mismos de la app (devolución en rojo). */
export const COLORES_REVISION = {
  general: ["#6366F1", "#8B5CF6"],
  mantenimiento: ["#F59E0B", "#C2410C"],
  devolucion: ["#DC2626", "#C2410C"],
};

/**
 * Cabecera de color de Revisión en Sistemas (igual que ResumenRevision de la app): qué hay que
 * revisar, el avance como contadores y un mensaje final (check si [todoBien]).
 * contadores: [{ etiqueta, valor, total }] — valor null = aún calculando; sin total se muestra solo el valor.
 * onVerificar: muestra "Verificar" para volver a consultar.
 */
export default function ResumenRevision({
  titulo = "Revisión en Sistemas",
  descripcion,
  contadores = [],
  mensaje,
  todoBien = false,
  onVerificar,
  colores = COLORES_REVISION.general,
}) {
  return (
    <Box sx={{ p: 2, borderRadius: "12px", color: "#fff", background: `linear-gradient(135deg, ${colores[0]}, ${colores[1]})` }}>
      <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>{titulo}</Typography>
      {descripcion && <Typography variant="body2" sx={{ opacity: 0.9 }}>{descripcion}</Typography>}

      {contadores.length > 0 && (
        <Stack direction="row" spacing={1} sx={{ mt: 1.5 }}>
          {contadores.map((c) => <Contador key={c.etiqueta} {...c} />)}
        </Stack>
      )}

      {mensaje && (
        <Stack direction="row" alignItems="center" spacing={0.75} sx={{ mt: 1.5 }}>
          {todoBien ? <CheckCircleIcon sx={{ fontSize: 18 }} /> : <InfoOutlinedIcon sx={{ fontSize: 18 }} />}
          <Typography variant="body2" sx={{ fontWeight: 600, flex: 1 }}>{mensaje}</Typography>
          {onVerificar && (
            <Button
              size="small"
              startIcon={<RefreshIcon />}
              onClick={onVerificar}
              sx={{ color: "#fff", textTransform: "none", flexShrink: 0 }}
            >
              Verificar
            </Button>
          )}
        </Stack>
      )}
    </Box>
  );
}

function Contador({ etiqueta, valor, total }) {
  return (
    <Box sx={{ flex: 1, maxWidth: 180, py: 1, borderRadius: "10px", bgcolor: "rgba(255,255,255,0.18)", textAlign: "center" }}>
      {valor == null ? (
        <CircularProgress size={22} sx={{ color: "#fff", my: 0.25 }} />
      ) : (
        <Typography variant="h6" sx={{ fontWeight: 800, lineHeight: 1.2 }}>
          {total == null ? valor : `${valor}/${total}`}
        </Typography>
      )}
      <Typography variant="caption" sx={{ opacity: 0.9, display: "block" }}>{etiqueta}</Typography>
    </Box>
  );
}
